import axios from 'axios'
import AjaxError from './AjaxError'
import * as EventKeyMap from './EventKeys'

const CancelToken = axios.CancelToken

export default ({
  options,
  eventBus,
  getToken = () => ({}),
  sourceMap = {}
}) => {
  let ajax = axios.create(options)

  ajax.interceptors.request.use(config => {
    let source = sourceMap[config.sourceKey] = CancelToken.source()
    config.cancelToken = source.token

    let token = getToken()
    if (token) {
      config.headers[process.env.TOKEN_HEADER] = token
    }

    return config
  }, error => new Promise((resolve, reject) => reject(error)))

  ajax.interceptors.response.use(response => new Promise((resolve, reject) => {
    let data = response.data

    if (typeof data !== 'object' || data === null) {
      return reject(new AjaxError('数据格式不正确', 30000))
    }

    let code = data.code

    if (code === 200) {
      let responseConfig = response.config
      delete sourceMap[responseConfig.sourceKey]
      resolve(/^(blob)$/i.test(responseConfig.responseType) ? response : data.data)
    } else {
      let error = new AjaxError(data.msg, code)
      eventBus.emit(EventKeyMap.RESPONSE_ERROR, error)
      reject(error)
    }
  }), error => {
    if (error.message === EventKeyMap.REQUEST_CANCEL) {
      return
    }

    return new Promise((resolve, reject) => {
      let config = error.config

      if (config) {
        delete sourceMap[config.sourceKey]
      }

      if (!(error instanceof AjaxError)) {
        error = new AjaxError('服务器正忙', 500)
      }

      eventBus.emit(EventKeyMap.RESPONSE_ERROR, error)
      reject(error)
    })
  })

  return ajax
}



// WEBPACK FOOTER //
// ./src/apis/ajax/index.js